// extracted by mini-css-extract-plugin
module.exports = {"container":"founders-list_container__Nj5MS"};